// The public game version, shown under the brand in the nav. Sourced from
// package.json's `version` at build time (Vite `define`), so there's a single
// number to bump per patch - see CLAUDE.md ("Versioning & News").
declare const __GAME_VERSION__: string;

export const GAME_VERSION: string = typeof __GAME_VERSION__ === "string" ? __GAME_VERSION__ : "0.0.0";

// Build timestamp (Vite `define`), so a running client can show which build it is.
declare const __BUILD_TIME__: string;

export const BUILD_TIME: string = typeof __BUILD_TIME__ === "string" ? __BUILD_TIME__ : "";

// Compact UTC stamp like "Jun 12 16:18 UTC" for on-screen display.
export const BUILD_LABEL: string = (() => {
  if (!BUILD_TIME) return "dev";
  const d = new Date(BUILD_TIME);
  if (isNaN(d.getTime())) return "dev";
  const mon = d.toLocaleString("en-US", { month: "short", timeZone: "UTC" });
  const day = d.getUTCDate();
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mm = String(d.getUTCMinutes()).padStart(2, "0");
  return `${mon} ${day} ${hh}:${mm} UTC`;
})();
